import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ReceivedPaymentService', ReceivedPaymentService);

  ReceivedPaymentService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'moment',
    'ReceivedPaymentModalService',
    'WindowModalService',
  ];

  function ReceivedPaymentService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    moment,
    ReceivedPaymentModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'received_payments';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getReceivedPayments: getReceivedPayments,
      getReceivedPayment: getReceivedPayment,
      saveReceivedPayment: saveReceivedPayment,
      deleteReceivedPayment: deleteReceivedPayment,
      // updateReceivedPayments    : updateReceivedPayments,
      searchOpenPayments: searchOpenPayments,
      openSearchOpenPayments: openSearchOpenPayments,
      openItemReceivedPaymentModal: openItemReceivedPaymentModal,
      getRelatedTransactions: getRelatedTransactions,
      openRelatedTransactions: openRelatedTransactions,
      hasRelatedTransactions: hasRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filterCriteria;
    }

    function getReceivedPayments(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getReceivedPayment(id) {
      // if (!filterCriteria) {
      //   filterCriteria = {
      //     page: 1,
      //     sortDir: 'desc',
      //     sortedBy: 'date',
      //   };
      // }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveReceivedPayment(item) {
      var itemAddedMsg = $translate('PAYMENT_RECEIVED_ADDED');
      var itemModifiedMsg = $translate('PAYMENT_RECEIVED_MODIFIED');

      var dateFormatBD = config.DATE_FORMAT_DB;
      item.date = moment(item.date).format(dateFormatBD);

      var method = 'post';
      var url = apiUrl;

      if (item.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + item.id;
      }

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { received_payment: item }, success, failure);
    }

    function deleteReceivedPayment(receivedPayment, successCallback) {
      let url = apiUrl + '/' + receivedPayment.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: receivedPayment.company_id },
        function () {
          let params = {
            title: 'SURE_TO_DELETE_PAYMENT_RECEIVED',
            body: 'DELETING_PAYMENT_RECEIVED_WARNING',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'PAYMENT_RECEIVED_DELETED',
            company_id: receivedPayment.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function searchOpenPayments(filterCriteria) {
      var url = apiUrl + '/search_open_documents';

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function openSearchOpenPayments(filterCriteria, receivedPaymentDocuments, successCallback) {
      ReceivedPaymentModalService.openSearchOpenPayments(
        filterCriteria,
        receivedPaymentDocuments,
        successCallback
      );
    }

    function openItemReceivedPaymentModal(receivedPayment, mode, company, item, successCallback) {
      let openReceivedPayment = function (data) {
        let templateUrl =
          './app/ajs/received-payments/modals/item-received-payment-detail-modal.html';

        let modalParams = {
          title: 'PAYMENT_DETAILS',
          item: data,
          mode: mode,
          preventModalClose: true,
          additionalParams: {
            company: company,
            item: item, // invoice / booking
          },
        };

        let confirmCallback = function (response) {
          if (receivedPayment.id) {
            // Edit
            receivedPayment.payment_number = response.payment_number;
            receivedPayment.date = response.date;
            receivedPayment.reference_number = response.reference_number;
            // receivedPayment.authcode = response.authcode;
            receivedPayment.amount = response.amount;
            receivedPayment.amount_in_excess = response.amount_in_excess;
            receivedPayment.notes = response.notes;

            receivedPayment.user_id = response.user_id;
            receivedPayment.payment_method_code = response.payment_method_code;
            receivedPayment.payment_method_id = response.payment_method_id;
            receivedPayment.currency = response.currency;
            receivedPayment.currency_id = response.currency_id;
            receivedPayment.document_type_id = response.document_type_id;

            utils.itemListChanged(response.id);
          }

          return successCallback(response);
        };

        WindowModalService.open(templateUrl, modalParams, confirmCallback);
      };

      if (receivedPayment.id) {
        // View // Edit
        getReceivedPayment(receivedPayment.id, '').then(function (data) {
          openReceivedPayment(data);
        });
      } else {
        // Create
        openReceivedPayment(receivedPayment);
      }
    }

    function openRelatedTransactions(transaction, client) {
      let templateUrl =
        './app/ajs/received-payments/modals/received-payments-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          clientId: client.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },

        function (err) {
          return err;
        }
      );
    }

    function hasRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/has_related_transactions/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
